/**
 * Base45 encoder/decoder per RFC 9285.
 *
 * The 45-char alphabet matches QR alphanumeric mode exactly, so base45-encoded
 * data triggers the denser alphanumeric encoding (~5.5 bits/char vs 8 bits/char
 * in byte mode). No external dependency; works with Uint8Array in Node and browser.
 */
const CHARSET = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:";
const REVERSE = new Uint8Array(128);
REVERSE.fill(0xff);
for (let i = 0; i < CHARSET.length; i++) {
    REVERSE[CHARSET.charCodeAt(i)] = i;
}
export function base45Encode(data) {
    let out = "";
    for (let i = 0; i < data.length; i += 2) {
        if (i + 1 < data.length) {
            const x = (data[i] << 8) | data[i + 1];
            const e = Math.floor(x / 2025); // 45*45
            const d = Math.floor((x % 2025) / 45);
            const c = x % 45;
            out += CHARSET[c] + CHARSET[d] + CHARSET[e];
        }
        else {
            const d = Math.floor(data[i] / 45);
            const c = data[i] % 45;
            out += CHARSET[c] + CHARSET[d];
        }
    }
    return out;
}
export function base45Decode(input) {
    const buf = [];
    for (let i = 0; i < input.length; i += 3) {
        if (i + 2 < input.length) {
            const c = charVal(input, i);
            const d = charVal(input, i + 1);
            const e = charVal(input, i + 2);
            const x = c + d * 45 + e * 2025;
            if (x > 0xffff)
                throw new Error("Invalid base45 triplet");
            buf.push(x >> 8, x & 0xff);
        }
        else if (i + 1 < input.length) {
            const c = charVal(input, i);
            const d = charVal(input, i + 1);
            const x = c + d * 45;
            if (x > 0xff)
                throw new Error("Invalid base45 pair");
            buf.push(x);
        }
        else {
            throw new Error("Invalid base45 length");
        }
    }
    return new Uint8Array(buf);
}
function charVal(input, pos) {
    const code = input.charCodeAt(pos);
    if (code >= 128)
        throw new Error("Invalid base45 character");
    const val = REVERSE[code];
    if (val === 0xff)
        throw new Error("Invalid base45 character");
    return val;
}
//# sourceMappingURL=base45.js.map